<template>
    <div class="bwdjc">
        <el-form class="leader-style-form" inline>
            <el-form-item label="日期" label-width="40px">
                <el-date-picker
                    v-model="show_month"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    @change="handleFilterList()"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    style="float:left"
                ></el-date-picker>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button @click="handleFilterList()">查询</el-button>
            </el-form-item>
        </el-form>
        <el-scrollbar style="height: 90%">
            <div class="echart-container">
                <v-chart
                    :auto-resize="true"
                    :options="monthLine"
                    ref="monthLine"
                    theme="ovilia-green"
                />
            </div>
            <div class="echart-container" v-if="showDay">
                <v-chart
                    :auto-resize="true"
                    :options="dayLine"
                    ref="dayLine"
                    theme="ovilia-green"
                />
            </div>
            <div class="echart-container" v-if="showHour">
                <v-chart
                    :auto-resize="true"
                    :options="hourLine"
                    ref="hourLine"
                    theme="ovilia-green"
                />
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
export default {
    data() {
        return {
            show_month: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            monthLegend: [],
            monthX: [],
            monthY1: [],
            monthY2: [],
            showDay: false,
            selectLineMonth: "",
            dayLegend: [],
            dayX: [],
            dayY1: [],
            dayY2: [],
            showHour: false,
            selectLineDay: "",
            hourLegend: [],
            hourX: [],
            hour1: [],
            hour2: []
        };
    },
    created() {
        this.getSysDate();
    },
    mounted() {
        const monthLine = this.$refs.monthLine.chart;
        //使点击区域变成pointer
        monthLine.getZr().on("mousemove", function(params) {
            var pointInPixel = [params.offsetX, params.offsetY];
            if (monthLine.containPixel("grid", pointInPixel)) {
                monthLine.getZr().setCursorStyle("pointer");
            }
        });
        //折线图区域点击事件
        monthLine.getZr().on("click", params => {
            var pointInPixel = [params.offsetX, params.offsetY];
            var pointInGrid = monthLine.convertFromPixel("grid", pointInPixel);
            var category = monthLine.getModel().get("xAxis")[0].data[
                pointInGrid[0]
            ];
            if (undefined != category) {
                this.selectLineMonth = category;
                this.showDay = true;
                this.showHour = false;
                this.getDaysBwdjc(this.selectLineMonth);
            }
        });
    },
    methods: {
        getSysDate() {
            api.getSysDate().then(res => {
                if (res && res.error_code == 0) {
                    this.show_month = res.bus_json.sysdate3;
                    this.getMonthsBwdjc();
                }
            });
        },
        handleFilterList() {
            this.showDay = false;
            this.showHour = false;
            this.getMonthsBwdjc();
        },
        /**
         * @description: 获取月份数据
         */
        getMonthsBwdjc() {
            api.getMonthsBwdjc({ show_month: this.show_month }).then(res => {
                if (res && res.error_code == 0) {
                    this.monthX = res.bus_json.time_list;
                    this.monthLegend = [];
                    res.bus_json.tl.forEach(item => {
                        this.monthLegend.push(item.name);
                    });
                    this.monthY1 =
                        res.bus_json[
                            res.bus_json.tl[0].tree_unit_id
                        ].power_list;
                    this.monthY2 =
                        res.bus_json[
                            res.bus_json.tl[1].tree_unit_id
                        ].power_list;
                }
            });
        },
        getDaysBwdjc() {
            api.getDaysBwdjc({ show_month: this.selectLineMonth }).then(res => {
                if (res && res.error_code == 0) {
                    this.dayX = res.bus_json.time_list;
                    this.dayLegend = [];
                    res.bus_json.tl.forEach(item => {
                        this.dayLegend.push(item.name);
                    });
                    this.dayY1 =
                        res.bus_json[
                            res.bus_json.tl[0].tree_unit_id
                        ].power_list;
                    this.dayY2 =
                        res.bus_json[
                            res.bus_json.tl[1].tree_unit_id
                        ].power_list;

                    const dayLine = this.$refs.dayLine.chart;
                    //使点击区域变成pointer
                    dayLine.getZr().on("mousemove", function(params) {
                        var pointInPixel = [params.offsetX, params.offsetY];
                        if (dayLine.containPixel("grid", pointInPixel)) {
                            dayLine.getZr().setCursorStyle("pointer");
                        }
                    });
                    dayLine.getZr().off('click')
                    //折线图区域点击事件
                    dayLine.getZr().on("click", params => {
                        var pointInPixel = [params.offsetX, params.offsetY];
                        var pointInGrid = dayLine.convertFromPixel(
                            "grid",
                            pointInPixel
                        );
                        var category = dayLine.getModel().get("xAxis")[0].data[
                            pointInGrid[0]
                        ];
                        if (undefined != category) {
                            this.showHour = true;
                            this.selectLineDay = category;
                            this.getHoursBwdjc(category);
                        }
                    });
                }
            });
        },
        getHoursBwdjc() {
            api.getHoursBwdjc({ show_date: this.selectLineDay }).then(res => {
                if (res && res.error_code == 0) {
                    this.hourX = res.bus_json.time_list;
                    this.hourLegend = [];
                    res.bus_json.tl.forEach(item => {
                        this.hourLegend.push(item.name);
                    });
                    this.hourY1 =
                        res.bus_json[
                            res.bus_json.tl[0].tree_unit_id
                        ].power_list;
                    this.hourY2 =
                        res.bus_json[
                            res.bus_json.tl[1].tree_unit_id
                        ].power_list;
                }
            });
        }
    },
    computed: {
        monthLine() {
            const options = {
                title: {
                    // text: '变压器负载率趋势图'
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "10%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.monthLegend,
                    textStyle: {
                        color: "#fff"
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.monthX,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位(kWh)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.monthLegend[0],
                        type: "line",
                        data: this.monthY1,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    },
                    {
                        name: this.monthLegend[1],
                        type: "line",
                        data: this.monthY2,
                        itemStyle: {
                            normal: {
                                color: "#00b252", //点颜色
                                lineStyle: {
                                    color: "#00b252" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return options;
        },
        dayLine() {
            const option = {
                title: {
                    text: `${this.selectLineMonth}月数据`,
                    left: "center",
                    textStyle: {
                        color: "#fff"
                    }
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "20%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.dayLegend,
                    x: "center",
                    top: "8%",
                    textStyle: {
                        color: "#fff"
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.dayX,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位(kWh)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.dayLegend[0],
                        type: "line",
                        data: this.dayY1,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    },
                    {
                        name: this.dayLegend[1],
                        type: "line",
                        data: this.dayY2,
                        itemStyle: {
                            normal: {
                                color: "#00b252", //点颜色
                                lineStyle: {
                                    color: "#00b252" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return option;
        },
        hourLine() {
            const option = {
                title: {
                    text: `${this.selectLineDay}日数据`,
                    left: "center",
                    textStyle: {
                        color: "#fff"
                    }
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "20%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.hourLegend,
                    x: "center",
                    top: "8%",
                    textStyle: {
                        color: "#fff"
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.hourX,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        name: "单位(kWh)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.hourLegend[0],
                        type: "line",
                        data: this.hourY1,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    },
                    {
                        name: this.hourLegend[1],
                        type: "line",
                        data: this.hourY2,
                        itemStyle: {
                            normal: {
                                color: "#00b252", //点颜色
                                lineStyle: {
                                    color: "#00b252" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.bwdjc {
    width: 100%;
    height: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    .echart-container {
        width: 100%;
        margin-top: 20px;

        .echarts {
            width: 100% !important;
            height: 350px;
        }
    }
}
</style>
